var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-radio-group',{model:{value:(_vm.selectDate),callback:function ($$v) {_vm.selectDate=$$v},expression:"selectDate"}},_vm._l((_vm.reserveList),function(list,index){return _c('v-radio',{key:index,attrs:{"label":list.reserveSet.name,"value":list.reserveDate}})}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }